// Quazzi Cosmetics — minimal theme JS
document.addEventListener('DOMContentLoaded', function () {
  // Smooth scroll for on-page anchor links (nav, hero, story CTAs)
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
